var ProgressTimeline = /** @class */ (function () {
    function ProgressTimeline() {
        this.start = 0;
        this.end = 100;
    }
    ProgressTimeline.prototype.value = function (time) {
        if (time < this.start) {
            return 0;
        }
        if (time > this.end) {
            return 1;
        }
        return (time - this.start) / (this.end - this.start);
    };
    return ProgressTimeline;
}());
export { ProgressTimeline };
